var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_delete",
    fill: "#BA1312"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9248,18 L4.5698,18 L3.0288,4.278 L5.0128,4.278 L7.0128,4.278 L10.4818,4.278 L12.4818,4.278 L14.4648,4.278 L12.9248,18 Z M7.0128,2.278 L10.4818,2.278 L10.4818,2 L7.0128,2 L7.0128,2.278 Z M17.4938,2.278 L12.4818,2.278 L12.4818,1.912 C12.4818,0.857 11.6238,0 10.5708,0 L6.9238,0 C5.8698,0 5.0128,0.857 5.0128,1.912 L5.0128,2.278 L-0.0002,2.278 L-0.0002,4.278 L1.0178,4.278 L2.5988,18.371 C2.6798,19.284 3.4568,20 4.3678,20 L13.1258,20 C14.0368,20 14.8148,19.284 14.8938,18.394 L16.4778,4.278 L17.4938,4.278 L17.4938,2.278 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.586,15.535 L10.586,6.744 L12.086,6.744 L12.086,15.535 L10.586,15.535 Z M7.997,15.535 L7.997,6.744 L9.497,6.744 L9.497,15.535 L7.997,15.535 Z M5.408,15.535 L5.408,6.744 L6.908,6.744 L6.908,15.535 L5.408,15.535 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.825de635e8f22467ddf1f567ce7671e7.svg";
export { ForwardRef as ReactComponent };